import type { PersonnelDepartment, PersonnelHeadcount } from '../../shared/personnel';

export const PERSONNEL_BASE_MONTH='2025-04-01';
export const GROWTH_DEPARTMENTS=['病院全体','診療部','看護部','薬剤部','リハビリテーション部','検査・病理','栄養部','放射線部','CE部','EMT課','事務部'];
export type GrowthMetric='revenue'|'head'|'cost';
export type GrowthPoint={month:string;revenue:number|null;head:number|null;cost:number|null};

export function personnelGrowthPoints(rows:PersonnelDepartment[],heads:PersonnelHeadcount[],department:string):GrowthPoint[] {
  const months=[...new Set(rows.map(r=>r.month))].filter(m=>m>=PERSONNEL_BASE_MONTH).sort();
  return months.map(month=>{
    const common=rows.find(r=>r.month===month);
    const member=rows.find(r=>r.month===month&&r.department===department&&r.in_slide);
    return {month,revenue:common?.revenue_yen??null,
      head:department==='病院全体'?heads.find(h=>h.month===month&&h.level==='病院'&&h.label==='病院全体')?.fte??null:member?.headcount??null,
      cost:department==='病院全体'?common?.pl_net_total_yen??null:member?.allocated_cost_yen??null};
  });
}

export function relativeToPersonnelBase(value:number|null,baseline:number|null,index=false):number|null {
  if(value==null||baseline==null||!Number.isFinite(value)||!Number.isFinite(baseline)||baseline<=0)return null;
  return index?value/baseline*100:(value/baseline-1)*100;
}
